import { render } from "./quiz-result.vue?vue&type=template&id=d73fd02e&ts=true"
import script from "./quiz-result.vue?vue&type=script&lang=ts"
export * from "./quiz-result.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__